import React from 'react'

const PhoneIcon = (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.3893 3.21676L12.5255 1.35517C12.298 1.12772 11.9935 1 11.6715 1C11.3495 1 11.045 1.12597 10.8175 1.35517L8.81028 3.35848C8.58278 3.58593 8.45503 3.89211 8.45503 4.21404C8.45503 4.53771 8.58103 4.8404 8.81028 5.0696L10.3783 6.639C10.0211 7.47109 9.50785 8.22711 8.86628 8.86625C8.22403 9.51186 7.47328 10.021 6.64027 10.3814L5.07227 8.81201C4.84477 8.58456 4.54027 8.45684 4.21826 8.45684C4.05944 8.45626 3.90209 8.48737 3.75545 8.54836C3.6088 8.60934 3.47581 8.69898 3.36426 8.81201L1.35525 10.8153C1.12775 11.0428 1 11.349 1 11.6709C1 11.9946 1.126 12.2972 1.35525 12.5264L3.21726 14.388C3.60576 14.7764 4.14126 14.9986 4.69077 14.9986C4.80452 14.9986 4.91477 14.9899 5.02677 14.9706C7.34378 14.5892 9.64329 13.3558 11.5 11.5012C13.3551 9.64308 14.5871 7.34409 14.9721 5.02586C15.0823 4.368 14.8618 3.6909 14.3893 3.21676ZM13.7313 4.81765C13.3901 6.88044 12.2805 8.93799 10.6093 10.6089C8.93803 12.2797 6.88178 13.389 4.81852 13.7302C4.55952 13.7739 4.29351 13.6864 4.10451 13.4992L2.27576 11.6709L4.21476 9.73056L6.31127 11.8301L6.32702 11.8458L6.70502 11.7059C7.85115 11.2846 8.89195 10.6192 9.75527 9.75572C10.6186 8.89229 11.2838 7.8515 11.7048 6.70548L11.8448 6.32757L9.73079 4.21579L11.6698 2.27547L13.4986 4.10381C13.6876 4.29277 13.7751 4.55871 13.7313 4.81765Z"
      fill="currentColor"
    />
  </svg>
)

export default PhoneIcon
